<app-confirm-action-modal
  testId="delete-prepaid-wash-book-dialog"
  title="Delete Prepaid Wash Book?"
  confirmLabel="Delete"
  busyLabel="Deleting..."
  [busy]="loading"
  [mobileSheet]="false"
  (confirm)="onConfirm()"
  (cancel)="onClose()"
>
  <p>
    @if (book; as selectedBook) {
      Are you sure you want to delete "{{ selectedBook.name }}"? This action cannot be undone.
    } @else {
      Are you sure you want to delete this prepaid wash book? This action cannot be undone.
    }
  </p>
</app-confirm-action-modal>
